import React from 'react'
import {useDispatch} from 'react-redux'
import {addProjectSuccess} from '../action/actionCreators'
import API from 'config/API'
import {Notifier} from 'components/Notifier'
import {ModalContext} from 'context/ModalContext'
import ProjectForm from './ProjectForm'
import moment from 'moment'

const AddProject = () => {
  const [loading, setLoading] = React.useState(false)
  const {hideModal} = React.useContext(ModalContext)
  const dispatch = useDispatch()

  const onSubmit = async (values, setError) => {
    try {
      setLoading(true)
      const response = await API.post(`/crm/projects`, values)
      setLoading(false)
      dispatch(addProjectSuccess(response.data.data))
      hideModal()
      Notifier.successMessage('Project has been created!')
    } catch (error) {
      for (let err in error.response.data.errors) {
        setError(err, {message: error.response.data.errors[err][0]})
      }
      setLoading(false)
    }
  }

  return (
    <ProjectForm
      onSubmitHandler={onSubmit}
      initialValues={{
        name: '',
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      }}
      loading={loading}
    />
  )
}

export default AddProject
